import * as routesUtils from '../utils/RoutesUtils'
import { API } from '../core/app.routes'
import httpClient from '../core/httpClient'

const vehicleReportService = () => {
  return {
    many: params => {
      const path = routesUtils.getApiPath(API.ADAS_REPORTS, params)
      return httpClient.get(path)
    },
    get: id => {
      const path = routesUtils.getApiPath(API.ADAS_REPORT_DETAIL, { id })
      return httpClient.get(path)
    },
    updateReadiness: ({ id, calibrationReady, note }) => {
      const path = routesUtils.getApiPath(API.ADAS_REPORT_READINESS, { id })
      return httpClient.put(path, { calibrationReady, note })
    },
    upload: ({ vendorId, fileURL, fileName, calibrationReady, note }) => {
      const path = routesUtils.getApiPath(API.ADAS_REPORT_UPLOAD)
      return httpClient.post(path, { vendorId, fileURL, fileName, calibrationReady, note })
    },
    vendors: () => {
      const path = routesUtils.getApiPath(API.ADAS_REPORT_VENDORS)
      return httpClient.get(path)
    },
  }
}

export default vehicleReportService
